import { FE_HELP_CENTER_BRAND_AI_CHATBOT_241112 } from "@faire/help-center-settings/FE_HELP_CENTER_BRAND_AI_CHATBOT_241112";

import { useAssignSetting, useSetting } from "./useSetting";

export const useSettingHelpCenterBrandAIChatbot = (): boolean =>
  useSetting(FE_HELP_CENTER_BRAND_AI_CHATBOT_241112);

export const useAssignSettingHelpCenterBrandAIChatbot = () =>
  useAssignSetting(FE_HELP_CENTER_BRAND_AI_CHATBOT_241112);
